const initialState = {
  data: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    users: []
  },
  user: {},
  loggedUser: {},
  isLoading: false,
  hasErrored: false,
  isSubmiting: false,
  isSubmited: false,
  filesUploading: {
    showFileUploadedMessage: false,
    successUploaded: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case '[USERS] HAS_ERRORED':
      return { ...initialState, loggedUser: state.loggedUser, hasErrored: true };
    case '[USERS] IS_LOADING':
      return { ...initialState, loggedUser: state.loggedUser, isLoading: true };
    case '[USERS] IS_SUBMITING':
      return { ...state, isSubmiting: true, user: action.user };
    case '[USERS] IS_SUBMITED':
      return { ...state, isSubmiting: false, isSubmited: true };
    case '[USERS] CLEAR_SUBMITED':
      return { ...state, isSubmiting: false, isSubmited: false };
    case '[USERS] FETCH_SUCCESS':
      return { ...initialState, loggedUser: state.loggedUser, data: action.data };
    case '[USERS] GET_SUCCESS':
      return { ...initialState, loggedUser: state.loggedUser, user: action.user };
    case '[USERS] CREATE_SUCCESS':
      return { ...initialState, loggedUser: state.loggedUser, user: action.user };
    case '[USERS] UPDATE_SUCCESS':
      return { ...initialState, loggedUser: state.loggedUser, user: action.user };
    case '[USERS] LOGGED_HAS_ERRORED':
      return { ...state, hasErrored: true, isLoading: false };
    case '[USERS] LOGGED_IS_LOADING':
      return { ...state, hasErrored: false, isLoading: true };
    case '[USERS] LOGGED_GET_SUCCESS':
      sessionStorage.setItem('profile', action.user.profile.name);
      return { ...state, hasErrored: false, isLoading: false, loggedUser: action.user };

    case '[FILES] FILES_UPLOADED_SUCCESS':
      return { ...state, filesUploading: { ...initialState.filesUploading, showFileUploadedMessage: action.file.showFileUploadedMessage, successUploaded: action.file.successUploaded } };

    case '[FILES] FILES_UPLOADED_SUCCESS_HIDE_MESSAGE':
      return { ...state, filesUploading: { ...initialState.filesUploading, showFileUploadedMessage: action.file.showFileUploadedMessage, successUploaded: action.file.successUploaded } };

    default:
      return state;
  }
};
